/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_ErrorInputs */

const en_chat_error = /** @type {(inputs: Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again, or contact us.`)
};

const th_chat_error = /** @type {(inputs: Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง หรือติดต่อเรา`)
};

const ja_chat_error = /** @type {(inputs: Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again, or contact us.`)
};

const fr_chat_error = /** @type {(inputs: Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again, or contact us.`)
};

const es_chat_error = /** @type {(inputs: Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again, or contact us.`)
};

const ru_chat_error = /** @type {(inputs: Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again, or contact us.`)
};

const zh_chat_error = /** @type {(inputs: Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again, or contact us.`)
};

const vi_chat_error = /** @type {(inputs: Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã có lỗi xảy ra. Vui lòng thử lại hoặc liên hệ với chúng tôi.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please try again, or contact us." |
*
* @param {Chat_ErrorInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_error = /** @type {((inputs?: Chat_ErrorInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_ErrorInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_error(inputs)
	if (locale === "ja") return ja_chat_error(inputs)
	if (locale === "fr") return fr_chat_error(inputs)
	if (locale === "es") return es_chat_error(inputs)
	if (locale === "ru") return ru_chat_error(inputs)
	if (locale === "zh") return zh_chat_error(inputs)
	if (locale === "vi") return vi_chat_error(inputs)
	return en_chat_error(inputs)
});